import React from "react";
export const Flow = () => (
  <svg fill="none" viewBox="0 0 14 12">
    <path
      d="M10 5.33h2c.74 0 1.33-.6 1.33-1.33V1.33C13.33.59 12.73 0 12 0h-2c-.74 0-1.33.6-1.33 1.33V2h-4v-.67C4.67.59 4.07 0 3.34 0H1.33C.6 0 0 .6 0 1.33V4c0 .74.6 1.33 1.33 1.33h2c.74 0 1.33-.6 1.33-1.33v-.67H6V8c0 1.11.89 2 1.99 2h.67v.67c.01.74.61 1.33 1.34 1.33h2c.74 0 1.33-.6 1.33-1.33V8c0-.74-.6-1.33-1.33-1.33h-2c-.74 0-1.33.6-1.33 1.33v.67h-.68c-.36 0-.66-.3-.66-.66V3.33h1.33V4c.01.73.61 1.33 1.34 1.33z"
      fill="#192547"
    />
  </svg>
);
